import { render, staticRenderFns } from "./caigouFooter.vue?vue&type=template&id=e3b1d274"
import script from "./caigouFooter.vue?vue&type=script&lang=js"
export * from "./caigouFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports